module.exports = function (app) {
    app.controller('pages.account.contact-information', ['$scope', 'sessionData', 'modal', 'session', 'services', 'brand', 'aemContent', 'modal',
        function($scope, sessionData, modal, session, services, brand, aemContent, modal) {

            $scope.initFunction = function(){
                $scope.addAddressIndicator = true;
                $scope.showTempAddress = false;
                $scope.editing = {};
                $scope.editing.addresses = false;
                $scope.editing.phones = false;
                $scope.editing.emails = false;
                $scope.phoneMessage = false;
                $scope.emailUpdated = false;
            };

            $scope.initFunction();

            var lowerCaseBrand = sessionData.memberInfo.brand.toLowerCase();
            var ibcRelatedBrands = ["inac", "ibc", "ibccr", "ibx", "ibcah"];
            // if their brand is NOT IBC, show the item and link it like Medco
            if (ibcRelatedBrands.indexOf(lowerCaseBrand) == -1) {
                $scope.isIBC = false;
            }
            else{
                $scope.isIBC = true;
            }

            if(brand.current.sharedBrandCode ==='ndbcbs'){
                $scope.isNDBCBS = true;
                $scope.toolTip1 =  '<p>This address is where you will receive information about your benefits and health plan.</p> <p>If you have coverage through your employer,</p><p> please be sure to also notify your employer of any address change.</p>';
                $scope.toolTip1Alt =  'This address is where you will receive information about your benefits and health plan.If you have coverage through your employer, please be sure to also notify your employer of any address change.';
                $scope.toolTipUnconfirmed = '<p>You will not receive notifications and</p><p> information via email until your email is confirmed.</p>';
                $scope.toolTipUnconfirmedAlt = 'You will not receive notifications and information via email until your email is confirmed.';
                $scope.toolTip2 = '<p>This will not affect</p> <p>your coverage</p>';
                $scope.toolTip2Alt = 'This will not affect your coverage';
                $scope.toolTipNew = "We need to confirm your email before we send any benefits and service information.";
                $scope.toolTipNewAlt = "We need to confirm your email before we send any benefits and service information.";
            } else{
                $scope.isNDBCBS = false;
                $scope.toolTip1 =   '<p>Check your Contact Preferences</p> <p>to see what we will send by mail.</p>';
                $scope.toolTip1Alt = 'Check your Contact Preferences to see what we will send by mail.';
                $scope.toolTipUnconfirmed = '<p>We need to confirm your email</p> <p>before we send any benefits</p><p>and service information.</p>';
                $scope.toolTipUnconfirmedAlt = 'We need to confirm your email before we send any benefits and service information.';
                $scope.toolTip2 = '<p>This will not affect</p> <p>your coverage</p>';
                $scope.toolTip2Alt = 'This will not affect your coverage';
                $scope.toolTipNew = "We need to confirm your email before we send any benefits and service information.";
                $scope.toolTipNewAlt = "We need to confirm your email before we send any benefits and service information.";
            }

            $scope.accountSettingsRetrieveFunction = function()
            {
                services.rbsmbl.AccountSettingsRetrive()
                    .retriveAccountSettings(session.data.groupNumber, "ccsAccountSettings", session.data.memberInfo.brand, session.data.memberInfo.userName)
                    .then(function(accountSettingsData) {
                        if (accountSettingsData && accountSettingsData.data && accountSettingsData.data.payload) {

                            $scope.accountRetrieveData = accountSettingsData.data.payload;
                            var acctData = accountSettingsData.data.payload;
                            $scope.addresses = {};
                            $scope.addresses.permanent = {
                                "type" : "Permanent",
                                "line1": acctData.address1,
                                "line2": acctData.address2,
                                "line3": acctData.address3,
                                "line4": acctData.address4,
                                "county":acctData.county,
                                "city": acctData.city,
                                "state": acctData.state,
                                "zip": acctData.zip
                            };
                            $scope.addresses.temporary = {
                                "type" : "Other",
                                "line1": acctData.tempAddress1,
                                "line2": acctData.tempAddress2,
                                "line3": acctData.tempAddress3,
                                "line4": acctData.tempAddress4,
                                "county":null,
                                "city": acctData.tempCity,
                                "state": acctData.tempState,
                                "zip": acctData.tempZip
                            };

                            var selectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan();

                            if (acctData.getRelationshipCode != "Subscriber") {
                                $scope.disallowEdit = true;
                                $scope.disallowEditReason="Need to make changes? Please talk to the policyholder.";
                            }
                            else if (selectedPlan.productList[0] && selectedPlan.productList[0].hcrProduct && acctData.isDirectPay){
                                // If user is HCR ON-Exchange
                                if (selectedPlan.productList[0].hcrProduct === "ON"){
                                    $scope.disallowEdit = true;
                                    $scope.disallowEditReason="Need to make changes? Find out how you can <a class='emailLink' data-ng-click='hcrRedirect()'>update your address</a>.";
                                    // If user is HCR OFF-Exchange
                                }else{
                                    $scope.allowTempAddress = true;
                                    $scope.disallowEditReason="Need to make changes? Find out how you can <a class='emailLink' data-ng-click='hcrRedirect()'>update your permanent address</a>";
                                }
                            }
                            else if (!(acctData.isDirectPay || acctData.isDirectPayMedicare || acctData.isGroupMedicare)) {
                                $scope.disallowEdit = true;
                                $scope.disallowEditReason="Need to make changes? Please talk to your employer.";
                            }
                            else {
                                // if (model.isDirectPay || model.isDirectPayMedicare || model.isGroupMedicare) {
                                $scope.allowTempAddress = true;
                                $scope.showCounty = true;
                                $scope.disallowEditReason="Need to make changes? Please call the number on the back of your member ID card.";
                            }

                            if (acctData.isDirectPayMedicare || acctData.isGroupMedicare){
                                $scope.addAddressMessage="Living somewhere else for part of the year? We can send your mail to that address instead.";
                            }else{
                                $scope.addAddressMessage="If you want, we can send your mail to a different address.";
                            }

                            if (acctData.tempAddress1) {
                                $scope.hasTempAddress = true;

                            }else{
                                $scope.hideFooter = true;
                            }

                            if (acctData.address1) {
                                $scope.hasAddress = true;
                            }

                            if ($scope.allowTempAddress && $scope.hasTempAddress) {
                                $scope.showTempAddress = true;
                            }
                            if ($scope.allowTempAddress && !$scope.hasTempAddress && !$scope.disallowEdit) {
                                $scope.showAddAnotherAddress = true;
                            }


                            if(brand.current.sharedBrandCode === 'mincr' || brand.current.sharedBrandCode === 'mn'){
                                $scope.isMn = true;

                                aemContent.get('MER_CNTCTINFO_EXPIRED_CODE_EMAIL_FORMN').then(function (data){
                                    if (data == undefined){
                                        $scope.MER_CNTCTINFO_EXPIRED_CODE_EMAIL_FORMN = 'Please enter the code we sent to this email address. <br />' +
                                            'If it was more than 7 days ago, you will have to <a data-click="emailConfirmRequest()">request a new confirmation email.</a> <br />' +
                                            'Please click the request link only once so you don\'t receive multiple emails.<br /> It may take up to an hour to receive your email.';
                                    }
                                });
                            }

                            $scope.phones = [];
                            $scope.phones.push({ type: 'home', value: $scope.formatPhoneCustom(acctData.homePhone) });
                            $scope.phones.push({ type: 'work', value: $scope.formatPhoneCustom(acctData.workPhone) });
                            $scope.phones.push({ type: 'mobile', value: $scope.formatPhoneCustom(acctData.mobilePhone) });
                            $scope.phonesCopy = angular.copy($scope.phones);

                            $scope.emails = {};
                            $scope.emails.personal = { type: 'Personal', email: {value: acctData.emailAddress} };
                            if(acctData.workEmailAddress){
                                $scope.emails.work = { type: 'Work', email: {value: acctData.workEmailAddress} };
                                $scope.emails.work = { type: 'Work', email: {value: acctData.workEmailAddress ? acctData.workEmailAddress : 'None'} };
                            };
                            $scope.emails.isConfirmed = (acctData.emailConfirmedInd && acctData.emailConfirmedInd.toLowerCase() === 'confirmed');
                            $scope.emails.validationCode = null;
                            $scope.emailsCopy = angular.copy($scope.emails);
                        }
                    });
            };
            $scope.accountSettingsRetrieveFunction();

            $scope.formatPhoneCustom = function(phoneNum) {
                if (phoneNum && phoneNum.length > 0) {
                    var newNum = phoneNum.match(/[0-9]*/g).join('');
                    return '('+newNum.substr(0,3)+') '+newNum.substr(3,3)+'-'+newNum.substr(6,4);
                }
            };

            $scope.heading = "Contact Information";
            $scope.editPhone = false;
            $scope.emailEdit = false;
            $scope.changeNumber = {
                home: "1231234123",
                work: "1231231234",
                mobile: "1231231235"
            };

            window.$scope = $scope;
            $scope.editSwitch = function (key) {
                $scope[key] = !$scope[key];
            };

            $scope.switchToFalse = function (key) {
                $scope[key] = false;
            };

            // $scope.openModal = function () {
            //     modal.open({
            //         templateUrl: require('modals/contactInformationEmailModal.html'),
            //         scope: $scope,
            //         classes: 'contct-information-email-modal'
            //     })
            // };

            $scope.cancelphones = function(){
                //$scope.accountSettingsRetrieveFunction();
                $scope.phones = $scope.phonesCopy;
                $scope.phonesCopy = angular.copy($scope.phones);
                $scope.editSwitch('editPhone');
            };

            $scope.cancelemails = function(){
                //$scope.accountSettingsRetrieveFunction();
                $scope.emails = $scope.emailsCopy;
                $scope.emailsCopy = angular.copy($scope.emails);
                $scope.editSwitch('emailEdit');

            };

            $scope.saveemails = function(){
                $scope.emailButtonsDisabled = true;
                $scope.buildPayloadEmail = $scope.emails.personal.email.value;
                services.rbsmbl.AccountSettingsRetrive()
                    .retriveAccountSettings(session.data.groupNumber, "AccountSettings", session.data.memberInfo.brand, session.data.memberInfo.userName)
                    .then(function(accountSettingsData) {
                        if (accountSettingsData && accountSettingsData.data && accountSettingsData.data.payload) {
                            $scope.accountRetrieveData = accountSettingsData.data.payload;
                            var payload = {
                                "brand": session.data.memberInfo.brand,
                                "groupNumber":session.data.groupNumber,
                                "address1":$scope.accountRetrieveData.address1,
                                "address2":$scope.accountRetrieveData.address2,
                                "address3":$scope.accountRetrieveData.address3,
                                "address4":$scope.accountRetrieveData.address4,
                                "city":$scope.accountRetrieveData.city,
                                "state":$scope.accountRetrieveData.state,
                                "zip":$scope.accountRetrieveData.zip,
                                "mobilePhone": $scope.accountRetrieveData.mobilePhone,
                                "secureTextMessageOptInOut":"",
                                "intakeRequest":{
                                    "bdUserId":session.data.memberInfo.bvUserId,
                                    "contactFirstName":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.firstName,
                                    "contactLastName":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.lastName,
                                    "memberFirstName":session.data.memberInfo.firstName,
                                    "memberLastName":session.data.memberInfo.lastName,
                                    "birthDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.birthDate,
                                    "gender":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].gender,
                                    "relationshipCode":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].relationshipCode,
                                    "enrollmentSourceCode":session.data.memberInfo.clientList[0].enrollmentSourceCode,
                                    "ecId":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].ecId,
                                    "umi":session.data.memberInfo.umi,
                                    "lob":session.data.memberInfo.clientList[0].groupList[0].productList[0].lob,
                                    "alphaPrefix":session.data.memberInfo.clientList[0].groupList[0].productList[0].alphaPrefix,
                                    "groupNumber":session.data.memberInfo.clientList[0].groupList[0].groupNumber,
                                    "benefitPlanName":session.data.memberInfo.clientList[0].groupList[0].productList[0].benefitPlanName,
                                    "coverageBeginDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].coverageBeginDate,
                                    "coverageEndDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].coverageEndDate,
                                    "agreementId":session.data.memberInfo.agreementId,
                                    "clientName":session.data.memberInfo.clientList[0].clientName,
                                    "clientId":session.data.memberInfo.clientList[0].clientId,
                                    "coveredIndividualId":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].coveredIndividualId,
                                    "internalGroupNumber":session.data.memberInfo.clientList[0].groupList[0].internalGroupNumber
                                },
                                "emailAddress":$scope.buildPayloadEmail
                            };

                            services.rbsmbl.AccountSettingsRetrive()
                                .saveAccountSettings(payload, "AccountSettings", session.data.memberInfo.brand, session.data.memberInfo.userName)
                                .then(function(accountSettingsDataResponse) {
                                    $scope.editSwitch('emailEdit');
                                    $scope.emailUpdated = true;
                                    $scope.emails.isConfirmed = false;
                                    $scope.emailButtonsDisabled = false;
                                    if($scope.isIBC){
                                        modal.open({
                                            heading : "Next Steps",
                                            template : "<p class='margin-bottom'>You have successfully changed your email address. We need to confirm it before we can send any benefits & service information. You will soon receive an email with a confirmation code.</p><p class='margin-bottom'>When you get it, you will need to enter the code from the email into the confirmation code box.</p><p class='modal-disclaimer italic margin-bottom'>Please note that the code will only work for 7 days. After 7 days, you will have to request a new confirmation code.</p><p class='text-r'><button data-ng-click='closeModal()' class='action-btn'>OK</button></p>"
                                        });
                                    }
                                    else{
                                        modal.open({
                                            heading : "Next Steps",
                                            template : "<p class='margin-bottom'>You will soon receive an email with the confirmation link and code. When you get it, you can:</p><ol class='list-items'><li>1.Log in on the page that opens up.</li></ol><p class='text-c margin-top margin-bottom font-bold'>- or -</p><ol class='list-items'><li>1.Enter the code from the email into the confirmation code box.</li><li>2.Click the Confirm button.</li></ol><p class='modal-disclaimer italic margin-bottom'>Please note that both the code and link will only work for 7 days. After 7 days, you will have to request a new confirmation email.</p><p class='text-r'><button data-ng-click='closeModal()' class='action-btn'>OK</button></p>"
                                        });
                                    }
                                },function (accountSettingsDataResponseFail) {
                                        $scope.emailButtonsDisabled = false;
                                        modal.open({
                                            heading : "Error",
                                            template : "<p>Request failed, please try again.</p><p class='text-r'><button data-ng-click='closeModal()' class='action-btn'>OK</button></p>"
                                        });
                                });
                        }
                    });
            };

            $scope.savephones = function(){
                $scope.phoneButtonsDisabled = true;
                $scope.buildPayloadPhone = $scope.phones;
                if($scope.buildPayloadPhone[0].value){
                    $scope.buildPayloadPhone[0].value = $scope.buildPayloadPhone[0].value.replace(/\D/g,'');
                }
                if($scope.buildPayloadPhone[1].value){
                    $scope.buildPayloadPhone[1].value = $scope.buildPayloadPhone[1].value.replace(/\D/g,'');
                }
                if($scope.buildPayloadPhone[2].value){
                    $scope.buildPayloadPhone[2].value = $scope.buildPayloadPhone[2].value.replace(/\D/g,'');
                }
                services.rbsmbl.AccountSettingsRetrive()
                    .retriveAccountSettings(session.data.groupNumber, "AccountSettings", session.data.memberInfo.brand, session.data.memberInfo.userName)
                    .then(function(accountSettingsData) {
                        if (accountSettingsData && accountSettingsData.data && accountSettingsData.data.payload) {
                            $scope.accountRetrieveData = accountSettingsData.data.payload;
                            var payload = {
                                "brand": session.data.memberInfo.brand,
                                "groupNumber":session.data.groupNumber,
                                "address1":$scope.accountRetrieveData.address1,
                                "address2":$scope.accountRetrieveData.address2,
                                "address3":$scope.accountRetrieveData.address3,
                                "address4":$scope.accountRetrieveData.address4,
                                "city":$scope.accountRetrieveData.city,
                                "state":$scope.accountRetrieveData.state,
                                "zip":$scope.accountRetrieveData.zip,
                                "mobilePhone": $scope.buildPayloadPhone[2].value,
                                "secureTextMessageOptInOut":"",
                                "intakeRequest":{
                                    "bdUserId":session.data.memberInfo.bvUserId,
                                    "contactFirstName":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.firstName,
                                    "contactLastName":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.lastName,
                                    "memberFirstName":session.data.memberInfo.firstName,
                                    "memberLastName":session.data.memberInfo.lastName,
                                    "birthDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.birthDate,
                                    "gender":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].gender,
                                    "relationshipCode":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].relationshipCode,
                                    "enrollmentSourceCode":session.data.memberInfo.clientList[0].enrollmentSourceCode,
                                    "ecId":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].ecId,
                                    "umi":session.data.memberInfo.umi,
                                    "lob":session.data.memberInfo.clientList[0].groupList[0].productList[0].lob,
                                    "alphaPrefix":session.data.memberInfo.clientList[0].groupList[0].productList[0].alphaPrefix,
                                    "groupNumber":session.data.memberInfo.clientList[0].groupList[0].groupNumber,
                                    "benefitPlanName":session.data.memberInfo.clientList[0].groupList[0].productList[0].benefitPlanName,
                                    "coverageBeginDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].coverageBeginDate,
                                    "coverageEndDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].coverageEndDate,
                                    "agreementId":session.data.memberInfo.agreementId,
                                    "clientName":session.data.memberInfo.clientList[0].clientName,
                                    "clientId":session.data.memberInfo.clientList[0].clientId,
                                    "coveredIndividualId":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].coveredIndividualId,
                                    "internalGroupNumber":session.data.memberInfo.clientList[0].groupList[0].internalGroupNumber
                                },
                                "homePhone":$scope.buildPayloadPhone[0].value,
                                "workPhone":$scope.buildPayloadPhone[1].value
                            };

                            services.rbsmbl.AccountSettingsRetrive()
                                .saveAccountSettings(payload, "AccountSettings", session.data.memberInfo.brand, session.data.memberInfo.userName)
                                .then(function(accountSettingsDataResponse) {
                                    $scope.buildPayloadPhone[0].value = $scope.formatPhoneCustom($scope.buildPayloadPhone[0].value);
                                    $scope.buildPayloadPhone[1].value = $scope.formatPhoneCustom($scope.buildPayloadPhone[1].value);
                                    $scope.buildPayloadPhone[2].value = $scope.formatPhoneCustom($scope.buildPayloadPhone[2].value);
                                    $scope.editSwitch('editPhone');
                                    $scope.phoneMessage = true;
                                    $scope.phoneButtonsDisabled = false;
                                });
                        }
                    });

            };

            $scope.saveconfirmcode = function(){
                if($scope.emails.validationCode){
                    $scope.confirmButtonsDisabled = true;
                    $scope.validationCodeTemp = $scope.emails.validationCode;
                    services.rbsmbl.AccountSettingsRetrive()
                        .retriveAccountSettings(session.data.groupNumber, "AccountSettings", session.data.memberInfo.brand, session.data.memberInfo.userName)
                        .then(function(accountSettingsData) {
                            if (accountSettingsData && accountSettingsData.data && accountSettingsData.data.payload) {
                                $scope.accountRetrieveData = accountSettingsData.data.payload;
                                var payload = {
                                    "brand": session.data.memberInfo.brand,
                                    "groupNumber":session.data.groupNumber,
                                    "address1":$scope.accountRetrieveData.address1,
                                    "address2":$scope.accountRetrieveData.address2,
                                    "address3":$scope.accountRetrieveData.address3,
                                    "address4":$scope.accountRetrieveData.address4,
                                    "city":$scope.accountRetrieveData.city,
                                    "state":$scope.accountRetrieveData.state,
                                    "zip":$scope.accountRetrieveData.zip,
                                    "mobilePhone": $scope.accountRetrieveData.mobilePhone,
                                    "secureTextMessageOptInOut":"",
                                    "intakeRequest":{
                                        "bdUserId":session.data.memberInfo.bvUserId,
                                        "contactFirstName":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.firstName,
                                        "contactLastName":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.lastName,
                                        "memberFirstName":session.data.memberInfo.firstName,
                                        "memberLastName":session.data.memberInfo.lastName,
                                        "birthDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.birthDate,
                                        "gender":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].gender,
                                        "relationshipCode":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].relationshipCode,
                                        "enrollmentSourceCode":session.data.memberInfo.clientList[0].enrollmentSourceCode,
                                        "ecId":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].ecId,
                                        "umi":session.data.memberInfo.umi,
                                        "lob":session.data.memberInfo.clientList[0].groupList[0].productList[0].lob,
                                        "alphaPrefix":session.data.memberInfo.clientList[0].groupList[0].productList[0].alphaPrefix,
                                        "groupNumber":session.data.memberInfo.clientList[0].groupList[0].groupNumber,
                                        "benefitPlanName":session.data.memberInfo.clientList[0].groupList[0].productList[0].benefitPlanName,
                                        "coverageBeginDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].coverageBeginDate,
                                        "coverageEndDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].coverageEndDate,
                                        "agreementId":session.data.memberInfo.agreementId,
                                        "clientName":session.data.memberInfo.clientList[0].clientName,
                                        "clientId":session.data.memberInfo.clientList[0].clientId,
                                        "coveredIndividualId":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].coveredIndividualId,
                                        "internalGroupNumber":session.data.memberInfo.clientList[0].groupList[0].internalGroupNumber
                                    },
                                    "validationCode":$scope.validationCodeTemp
                                };
                                services.rbsmbl.AccountSettingsRetrive()
                                    .saveAccountSettings(payload, "AccountSettings", session.data.memberInfo.brand, session.data.memberInfo.userName)
                                    .then(function(accountSettingsDataResponse) {
                                        $scope.confirmButtonsDisabled = false;
                                        $scope.emails.isConfirmed = true;
                                        $scope.emailUpdated = false;
                                    },function (accountSettingsDataResponseFail) {
                                        $scope.confirmButtonsDisabled = false;
                                        if($scope.isMn){
                                            modal.open({
                                                heading : "Error",
                                                template : "<p>The confirmation code you entered is incorrect or may have expired. Please try again. If you've received multiple emails, use the code from the most recent one.</p><p class='text-r'><button data-ng-click='closeModal()' class='action-btn'>OK</button></p>"
                                            });
                                        }
                                        else if($scope.isNDBCBS){
                                            modal.open({
                                                heading : "Error",
                                                template : "<p>The confirmation code you entered is not correct.The format should be 7-digits.Please check and try again.</p><p class='text-r'><button data-ng-click='closeModal()' class='action-btn'>OK</button></p>"
                                            });
                                        }
                                        else{
                                            modal.open({
                                                heading : "Error",
                                                template : "<p>The confirmation code you entered is not correct. Please check and try again.</p><p class='text-r'><button data-ng-click='closeModal()' class='action-btn'>OK</button></p>"
                                            });
                                        }

                                    });
                            }
                        });
                }
            };

            $scope.emailConfirmRequest = function(){
                var emailId = $scope.emails.personal.email.value;
                var groupNo = session.data.groupNumber;
                services.rbsmbl.EmailConfirmationCode().sendConfirmCodeEmailNew(emailId,groupNo)
                    .then(function(emailConfirmCodeResponse) {
                        if($scope.isIBC){
                            modal.open({
                                heading : "Request Received",
                                template : "<p class='margin-bottom'>You will soon receive an email with the confirmation code. When you get it, you will need to enter the code from the email into the confirmation code box.</p><p class='modal-disclaimer italic margin-bottom'>Please note that both the code and link will only work for 7 days. After 7 days, you will have to request a new confirmation email.</p>"
                            });
                        }
                        else{
                            modal.open({
                                heading : "Request Received",
                                template : "<p class='margin-bottom'>You will soon receive an email with the confirmation link and code. When you get it, you can:</p><ol class='list-items'><li>1.Click the 'confirm email' link.</li><li>2.Log in on the page that opens up.</li></ol><p class='italic text-c margin-top margin-bottom'>or</p><ol class='list-items'><li>1.Enter the code from the email into the confirmation code box.</li><li>2.Click the Confirm button.</li></ol><p class='modal-disclaimer italic margin-bottom'>Please note that both the code and link will only work for 7 days. After 7 days, you will have to request a new confirmation email.</p><p class='text-r'><button data-ng-click='closeModal()' class='action-btn'>OK</button></p>"
                            });
                        }

                    },function (emailConfirmCodeResponseFail) {
                        modal.open({
                            heading : "Error",
                            template : "<p>Request failed, please try again.</p><p class='text-r'><button data-ng-click='closeModal()' class='action-btn'>OK</button></p>"
                        });
                    });
            };

            $scope.removeAddressTemp = function(){
                modal.open({
                    heading : "Remove Other Address",
                    template : "<p>Are you sure you want to remove this address?</p><p class='text-r'><button data-ng-click='closeModal()' class='action-btn secondary'>Cancel</button><button onclick='removeAddressTempSave()' data-ng-click='closeModal()' class='action-btn'>Remove</button></p>"
                });
            };

            removeAddressTempSave = function(){
                services.rbsmbl.AccountSettingsRetrive()
                    .retriveAccountSettings(session.data.groupNumber, "AccountSettings", session.data.memberInfo.brand, session.data.memberInfo.userName)
                    .then(function(accountSettingsData) {
                        if (accountSettingsData && accountSettingsData.data && accountSettingsData.data.payload) {
                            $scope.accountRetrieveData = accountSettingsData.data.payload;
                            var payload = {
                                "brand": session.data.memberInfo.brand,
                                "groupNumber":session.data.groupNumber,
                                "address1":$scope.accountRetrieveData.address1,
                                "address2":$scope.accountRetrieveData.address2,
                                "address3":$scope.accountRetrieveData.address3,
                                "address4":$scope.accountRetrieveData.address4,
                                "city":$scope.accountRetrieveData.city,
                                "state":$scope.accountRetrieveData.state,
                                "zip":$scope.accountRetrieveData.zip,
                                "mobilePhone": $scope.accountRetrieveData.mobilePhone,
                                "secureTextMessageOptInOut":"",
                                "intakeRequest":{
                                    "bdUserId":session.data.memberInfo.bvUserId,
                                    "contactFirstName":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.firstName,
                                    "contactLastName":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.lastName,
                                    "memberFirstName":session.data.memberInfo.firstName,
                                    "memberLastName":session.data.memberInfo.lastName,
                                    "birthDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].contact.birthDate,
                                    "gender":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].gender,
                                    "relationshipCode":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].relationshipCode,
                                    "enrollmentSourceCode":session.data.memberInfo.clientList[0].enrollmentSourceCode,
                                    "ecId":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].ecId,
                                    "umi":session.data.memberInfo.umi,
                                    "lob":session.data.memberInfo.clientList[0].groupList[0].productList[0].lob,
                                    "alphaPrefix":session.data.memberInfo.clientList[0].groupList[0].productList[0].alphaPrefix,
                                    "groupNumber":session.data.memberInfo.clientList[0].groupList[0].groupNumber,
                                    "benefitPlanName":session.data.memberInfo.clientList[0].groupList[0].productList[0].benefitPlanName,
                                    "coverageBeginDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].coverageBeginDate,
                                    "coverageEndDate":session.data.memberInfo.clientList[0].groupList[0].productList[0].coverageEndDate,
                                    "agreementId":session.data.memberInfo.agreementId,
                                    "clientName":session.data.memberInfo.clientList[0].clientName,
                                    "clientId":session.data.memberInfo.clientList[0].clientId,
                                    "coveredIndividualId":session.data.memberInfo.clientList[0].groupList[0].productList[0].memberList[0].coveredIndividualId,
                                    "internalGroupNumber":session.data.memberInfo.clientList[0].groupList[0].internalGroupNumber
                                },
                                "tempAddressCancelFlag":true
                            };

                            services.rbsmbl.AccountSettingsRetrive()
                                .saveAccountSettings(payload, "AccountSettings", session.data.memberInfo.brand, session.data.memberInfo.userName)
                                .then(function(accountSettingsDataResponse) {
                                    $scope.saveAddresses = true;
                                });
                        }
                    });
            };

            $scope.$watch(function(scope) { return scope.changeNumber.home },
                function(newValue, oldValue) {
                    newValue = newValue.replace(/\D/g,'');
                    if (/[0-9]/.test(newValue)) {
                        $scope.changeNumber.home = newValue;
                    }else if($scope.changeNumber.home = undefined) {
                        $scope.changeNumber.home = "";
                    }
                    console.log($scope.changeNumber.home);
                }
            );
            $scope.$watch(function(scope) { return scope.changeNumber.work },
                function(newValue, oldValue) {
                    newValue = newValue.replace(/\D/g,'');
                    if (/[0-9]/.test(newValue)) {
                        $scope.changeNumber.work = newValue;
                    }
                    console.log($scope.changeNumber.work);
                }
            );
            $scope.$watch(function(scope) { return scope.changeNumber.mobile },
                function(newValue, oldValue) {
                    newValue = newValue.replace(/\D/g,'');
                    if (/[0-9]/.test(newValue)) {
                        $scope.changeNumber.mobile = newValue;
                    }
                    console.log($scope.changeNumber.mobile);
                }
            );
        }
    ]);
};
